import { compiler } from '../../compiler';

export const identifiers = {
  ZodMiniOptional: compiler.identifier({ text: 'ZodMiniOptional' }),
  ZodOptional: compiler.identifier({ text: 'ZodOptional' }),
  _default: compiler.identifier({ text: '_default' }),
  and: compiler.identifier({ text: 'and' }),
  array: compiler.identifier({ text: 'array' }),
  bigint: compiler.identifier({ text: 'bigint' }),
  boolean: compiler.identifier({ text: 'boolean' }),
  check: compiler.identifier({ text: 'check' }),
  coerce: compiler.identifier({ text: 'coerce' }),
  date: compiler.identifier({ text: 'date' }),
  datetime: compiler.identifier({ text: 'datetime' }),
  default: compiler.identifier({ text: 'default' }),
  describe: compiler.identifier({ text: 'describe' }),
  email: compiler.identifier({ text: 'email' }),
  enum: compiler.identifier({ text: 'enum' }),
  globalRegistry: compiler.identifier({ text: 'globalRegistry' }),
  gt: compiler.identifier({ text: 'gt' }),
  gte: compiler.identifier({ text: 'gte' }),
  infer: compiler.identifier({ text: 'infer' }),
  int: compiler.identifier({ text: 'int' }),
  intersection: compiler.identifier({ text: 'intersection' }),
  ip: compiler.identifier({ text: 'ip' }),
  ipv4: compiler.identifier({ text: 'ipv4' }),
  ipv6: compiler.identifier({ text: 'ipv6' }),
  iso: compiler.identifier({ text: 'iso' }),
  lazy: compiler.identifier({ text: 'lazy' }),
  length: compiler.identifier({ text: 'length' }),
  literal: compiler.identifier({ text: 'literal' }),
  lt: compiler.identifier({ text: 'lt' }),
  lte: compiler.identifier({ text: 'lte' }),
  max: compiler.identifier({ text: 'max' }),
  maxLength: compiler.identifier({ text: 'maxLength' }),
  min: compiler.identifier({ text: 'min' }),
  minLength: compiler.identifier({ text: 'minLength' }),
  never: compiler.identifier({ text: 'never' }),
  null: compiler.identifier({ text: 'null' }),
  nullable: compiler.identifier({ text: 'nullable' }),
  number: compiler.identifier({ text: 'number' }),
  object: compiler.identifier({ text: 'object' }),
  optional: compiler.identifier({ text: 'optional' }),
  parseAsync: compiler.identifier({ text: 'parseAsync' }),
  readonly: compiler.identifier({ text: 'readonly' }),
  record: compiler.identifier({ text: 'record' }),
  regex: compiler.identifier({ text: 'regex' }),
  register: compiler.identifier({ text: 'register' }),
  string: compiler.identifier({ text: 'string' }),
  time: compiler.identifier({ text: 'time' }),
  tuple: compiler.identifier({ text: 'tuple' }),
  undefined: compiler.identifier({ text: 'undefined' }),
  union: compiler.identifier({ text: 'union' }),
  unknown: compiler.identifier({ text: 'unknown' }),
  url: compiler.identifier({ text: 'url' }),
  uuid: compiler.identifier({ text: 'uuid' }),
  void: compiler.identifier({ text: 'void' }),
  z: compiler.identifier({ text: 'z' }),
};

export const zodId = 'zod';
